let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("382Q7")).then(() => parcelRequire('c8Sc8'));